export function setLocalStorage(key: string, data: string | null | undefined): void {
  if (data == null) {
    localStorage.removeItem(key);
    return;
  }
  localStorage.setItem(key, data);
}

export function getLocalStorage(key: string): string | null {
  return localStorage.getItem(key);
}
